import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import "../styles/home.style.css";
import logo from "../assets/images/logo.png";
import mascot from "../assets/images/mascot-1.png";
import starGreen from "../assets/images/star-green.svg";
import starPink from "../assets/images/star-pink.svg";
import starWhite from "../assets/images/star-white.svg";
import cloudLogo from "../assets/images/logo.png";
import dividerPinkStar from "../assets/images/divider-pink-star.svg";
import itemImg1 from "../assets/images/left-radar-chart.png";
import itemImg2 from "../assets/images/radar-chart.png";
import matricMockup from "../assets/images/matrix-mock.png";
import strategicRadarChart from "../assets/images/strategic-radar.png";
import tailored90DayRoadmap from "../assets/images/tailored-mock.png";
import toolkit from "../assets/images/tool-kits.png";
import discoverMockImg from "../assets/images/discover-mock-img.png";
import footerLogo from "../assets/images/footer.svg";
import footerTopLogo from "../assets/images/footer-top.png";
const HomePage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleStart = () => {
    navigate("/loading");
  };

  return (
    <div className="container">
      <div className="container-fluid">
        <div className="home-page">
          <div className="header-control">
            <div className="header-control-left">
              <img src={logo} alt="logo" className="logo-white" />
              <div className="header-control-left-text">
                <h1
                  className="head-title-process-result-home"
                  dangerouslySetInnerHTML={{ __html: t("home.title") }}
                ></h1>
                <h1
                  className="head-title-process-result-home"
                  dangerouslySetInnerHTML={{ __html: t("home.title2") }}
                ></h1>
              </div>
            </div>
            <div className="header-control-right">
              <div className="header-control-right-text">
                <img src={footerTopLogo} alt="footerTopLogo" className="footer-top-logo" />
              </div>
            </div>
          </div>

          <div className="mascot-control">
            <img src={mascot} alt="mascot" className="mascot-img" />
            <img src={starGreen} alt="starGreen" className="star-green" />
            <img src={starPink} alt="starPink" className="star-pink" />
            <img src={starWhite} alt="starWhite" className="star-white" />
          </div>
          <div className="bubble-message-control">
            <div
              className="bubble-message-control-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage") }}
            ></div>
          </div>
          <div
            className="bubble-message-control-text"
            style={{ textAlign: "center", marginBottom: "16px" }}
            dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage2") }}
          ></div>
          <button
            className="button-dark button-start-bottom"
            onClick={handleStart}
          >
            {t("home.buttonStart")}
          </button>
          <div className="home-item-control">
            <img src={cloudLogo} alt="cloudLogo" className="cloud-logo" />
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage3") }}
            ></span>
            <br />
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage4") }}
            ></span>
            <img
              src={dividerPinkStar}
              alt="dividerPinkStar"
              className="divider-pink-star"
            />
            <span
              className="bubble-message-header-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage5") }}
            ></span>
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage6") }}
            ></span>

            <div className="item-img-grid-2-control">
              <img src={itemImg1} alt="itemImg1" className="item-img" />
              <img src={itemImg2} alt="itemImg2" className="item-img" />
            </div>
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage7") }}
            ></span>
            <img
              src={dividerPinkStar}
              alt="dividerPinkStar"
              className="divider-pink-star"
            />

            <div className="home-custom-header-section">
              <img
                src={starGreen}
                alt="starGreen"
                className="home-custom-star-green"
              />
              <img
                src={starPink}
                alt="starPink"
                className="home-custom-star-pink"
              />
              <div
                className="home-custom-header-section-text"
                dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage8") }}
              ></div>
              <span className="home-custom-header-section-text-impact">
                {t("home.bubbleMessage9")}
              </span>
            </div>
            <span className="bubble-message-normal-text">
              {t("home.bubbleMessage10")}
            </span>
            <div style={{ marginBottom: "24px" }}></div>
            <span className="bubble-message-header-text">
              {t("home.bubbleMessage11")}
            </span>
            <img
              src={matricMockup}
              alt="matricMockup"
              className="matrix-mockup"
            />
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage12") }}
            ></span>
            <img src={starPink} alt="starPink" className="star-pink-center" />
            <span className="bubble-message-header-text">
              {t("home.bubbleMessage13")}
            </span>
            <img
              src={strategicRadarChart}
              alt="strategicRadarChart"
              className="strategic-radar-chart"
            />
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage14") }}
            ></span>
            <img src={starGreen} alt="starGreen" className="star-pink-center" />
            <span
              className="bubble-message-header-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage15") }}
            ></span>
            <img
              src={tailored90DayRoadmap}
              alt="tailored90DayRoadmap"
              className="strategic-radar-chart"
            />
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage16") }}
            ></span>
            <img src={starGreen} alt="starGreen" className="star-pink-center" />
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage17") }}
            ></span>
            <img
              src={toolkit}
              alt="toolkit"
              className="strategic-radar-chart"
            />
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage18") }}
            ></span>
            <img
              src={dividerPinkStar}
              alt="dividerPinkStar"
              className="divider-pink-star"
            />
            <span className="bubble-message-header-text">
              {t("home.bubbleMessage19")}
            </span>
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage20") }}
            ></span>
            <div style={{ marginBottom: "24px" }}></div>
            <span
              className="bubble-message-normal-text"
              dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage21") }}
            ></span>
            <img
              src={discoverMockImg}
              alt="discoverMockImg"
              className="strategic-radar-chart"
            />
            <div className="bubble-message-control">
              <div
                className="bubble-message-control-text"
                dangerouslySetInnerHTML={{ __html: t("home.bubbleMessage22") }}
              ></div>
            </div>
            <button
              className="button-dark button-start-bottom"
              onClick={handleStart}
            >
              {t("home.bubbleMessage23")}
            </button>
            <img src={footerLogo} alt="footerLogo" className="footer-svg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
